<template>
    <div class="container">
        <!-- 背景柔光，静态，用于衬托卡片层次 -->
        <div class="bg-glow"></div>
        <!-- 波点层，极低对比度缓慢漂移，不干扰视觉焦点 -->
        <div class="bg-dots"></div>
        <div class="login">
            <div class="title">
                <img src="../assets/img/logo.png" alt="" />
                道乐科技 DAO
            </div>
            <div class="sub-title">欢迎您，请登录~</div>
            <feishu-login />
        </div>
    </div>
</template>

<script>
import FeishuLogin from "/src/component/FeishuLogin.vue"
export default {
    name: "login",
    components: { FeishuLogin },
    mounted(){
      document.getElementsByTagName('body')[0].style.zoom="unset"
    },
}
</script>

<style scoped>

/* 品牌蓝渐变背景，保持静态以突出登录卡片 */
.container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: linear-gradient(135deg, #4a90ff 0%, #2b5ce6 52%, #1f47c9 100%);
}

/* 卡片背后的静态柔光，增加层次但不抢焦点 */
.bg-glow {
    position: absolute;
    width: 620px;
    height: 620px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0) 68%);
    pointer-events: none;
    z-index: 0;
}

/* 波点层：低透明度白色圆点，缓慢对角漂移 */
.bg-dots {
    position: absolute;
    top: -40px;
    left: -40px;
    right: -40px;
    bottom: -40px;
    background-image: radial-gradient(rgba(255, 255, 255, 0.16) 1.5px, transparent 1.5px);
    background-size: 26px 26px;
    animation: dotsDrift 20s linear infinite;
    pointer-events: none;
    z-index: 0;
}

@keyframes dotsDrift {
    from { background-position: 0 0; }
    to   { background-position: 26px 26px; }
}

.login {
    position: relative;
    z-index: 2;
    box-sizing: border-box;
    width: 420px;
    padding: 32px 28px 28px;
    background-color: #fff;
    /* 圆角与内部卡片、按钮、图标风格统一 */
    border-radius: 16px;
    box-shadow: 0 18px 48px rgba(15, 39, 102, 0.28);
}

.login .title {
    font-size: 18px;
    font-weight: 600;
    color: #1f2d3d;
}

.login .title img {
    width: 30px;
    margin-right: 8px;
}

.login .title,
.login .sub-title {
    text-align: left;
    display: flex;
    align-items: center;
}

.login .sub-title {
    font-size: 14px;
    color: #8a94a6;
    margin-top: 8px;
}

/* 弱化系统动效偏好时关闭动画 */
@media (prefers-reduced-motion: reduce) {
    .bg-dots {
        animation: none;
    }
}

</style>
